export function hasMultiSelectSelection(...selectedItemCollections) {
	return selectedItemCollections.some((selectedItems) => Array.isArray(selectedItems) && selectedItems.length > 0);
}

export function getActiveMultiSelectType(selectedNavItem) {
	switch (selectedNavItem) {
		case "myChecklists":
			return "activities";
		case "organization":
			return "members";
		case "searchHistory":
			return "status";
		case "search":
			return "search";
		default:
			return null;
	}
}
